<template>
  <div class="side-presentation" v-if="content">
    <img :src="content.img" :alt="content.title">
    <div class="side-content">
      <h2 v-html="content.title"></h2>
      <p v-html="content.text"></p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      content: null
    },
    computed: {},
  };
</script>

<style lang="scss">
  .side-presentation {
    width:700px;
    max-width:90%;
    margin:auto;
    background-color:#edefed;
    border-radius:20px;
    overflow:hidden;
    box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.23);
    .side-content {
      padding:25px 20px;
    }
    img {
      border-radius:0;
    }
    h2 {
      padding-bottom:15px;
      font-family: "Muli", sans-serif;
      text-transform: uppercase;
      color: #484848;
    }
    p {
      color:$black;
      line-height: 1.2;
    }
  }
</style>
